import { createContext } from 'react';

export const SideDetailsContext = createContext(null);
